import React from 'react';
import { Alert, Button } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import useVersionCheck from '../../hooks/useVersionCheck';

const UpdateNotificationBanner = () => {
    const { t } = useTranslation();
    const { updateAvailable, refreshApp, dismissUpdate } = useVersionCheck();

    if (!updateAvailable) {
        return null;
    }

    return (
        <Alert
            message={t('updateNotification.title')}
            description={t('updateNotification.description')}
            type="warning"
            showIcon
            closable
            onClose={dismissUpdate}
            action={
                <Button
                    size="small"
                    type="primary"
                    icon={<ReloadOutlined />}
                    onClick={refreshApp}
                >
                    {t('updateNotification.refresh')}
                </Button>
            }
            style={{
                backgroundColor: 'rgb(255, 247, 230)',
                borderColor: 'rgb(255, 213, 145)',
                padding: '8px 16px',
                marginBottom: '1rem'
            }}
        />
    );
};

export default UpdateNotificationBanner;
